import clsx from "clsx";
import { useNavigationStylesByBrand } from "@RHCommerceDev/hooks/useTypographyStyles";
import React, { forwardRef, Ref } from "react";
import { Link, LinkProps } from "react-router-dom";
import memoize from "@RHCommerceDev/utils/memoize";

interface LinkpropsExt extends LinkProps {
  noLink?: boolean;
  classes?: any;
}
export const NavigationLink = forwardRef(
  (props: LinkpropsExt, ref: Ref<HTMLAnchorElement>) => {
    const { noLink, target = "_self", ...linkProps } = props;
    const typographyClasses = useNavigationStylesByBrand({
      keys: ["desktopCatalogLink"]
    });

    const targetUrl = props?.to?.toString();

    if (noLink) {
      return (
        <span
          data-nolink={props.dangerouslySetInnerHTML}
          className={clsx([
            "p-0",
            typographyClasses.desktopCatalogLink,
            props.classes,
            props?.className
          ])}
          dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
          style={{ lineHeight: "inherit" }}
        >
          {props.children}
        </span>
      );
    }
    try {
      new URL(targetUrl);
      return (
        <a
          ref={ref}
          href={targetUrl}
          target={target}
          style={props.style}
          className={clsx([
            typographyClasses.desktopCatalogLink,
            props.classes,
            props?.className
          ])}
        >
          {props.children}
        </a>
      );
    } catch {
      return (
        <Link
          ref={ref}
          {...linkProps}
          target={target}
          className={clsx([
            typographyClasses.desktopCatalogLink,
            props.classes,
            props?.className
          ])}
        >
          {props.children}
        </Link>
      );
    }
  }
);

export default memoize(NavigationLink);
